import _pickBy from 'lodash/pickBy';
import { GLOBAL_VARS } from '~/config';

const getVueScrollTo = () => import('vue-scrollto' /* webpackChunkName: "lib/vue-scrollto" */);
const { DESKTOP_STICKY_HEADER_HEIGHT, TABLET_STICKY_HEADER_HEIGHT } = GLOBAL_VARS.THEME;

const getScrollToDefaultOptions = ({ isDesktop, isTablet }) => {
    let offset = 0;

    if (isTablet) {
        offset = -TABLET_STICKY_HEADER_HEIGHT;
    } else if (isDesktop) {
        offset = -DESKTOP_STICKY_HEADER_HEIGHT;
    }

    return {
        offset,
        easing: 'ease-in',
        duration: 500,
    };
};

const scrollToFactory = async ({ store }, ...args) => {
    const { scrollTo } = await getVueScrollTo();
    const [element, options = {}] = args;

    return scrollTo(element, { ...getScrollToDefaultOptions(store.state.windowOptions), ..._pickBy(options, value => value !== undefined) });
};

export default function (context, inject) {
    inject('scrollTo', scrollToFactory.bind(null, context));
}
